import React, { SyntheticEvent } from 'react';

import { addParamsToUrl } from '@zapier/url-utils';
import GoogleButton from './GoogleButton';

type GoogleSSOButtonProps = {
  /** True to make button blue */
  isBlue?: boolean;

  /** True to make button large */
  isLarge?: boolean;

  /** Button Text */
  label: string;

  onClick?: (
    e: SyntheticEvent<HTMLAnchorElement>,
    href: string | undefined
  ) => any;

  /** Query params to be added to url */
  queryParams?: {};

  /** Google SSO URI */
  route?: string;
};
const defaultProps = {
  label: 'Sign up with Google',
  queryParams: {},
  route: '/google-sso/start',
};

export const GoogleSSOButton = (props: GoogleSSOButtonProps) => {
  const href = addParamsToUrl(
    props.route,
    {
      scopes: 'basic',
      ...props.queryParams,
    },
    true
  );
  return (
    <GoogleButton
      href={href}
      isBlue={props.isBlue}
      isLarge={props.isLarge}
      label={props.label}
      onClick={e => props.onClick && props.onClick(e, href)}
    />
  );
};

GoogleSSOButton.defaultProps = defaultProps;
